<div class="navbar navbar-inverse navbar-fixed-top">
  <div class="container">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" href="forside">Uggeløse Vandværk A.m.b.a.</a>
    </div>
    <div class="navbar-collapse collapse">
      <ul class="nav navbar-nav navbar-right">
        <li><a routerLinkActive="active" routerLink="/kundeservice">Kundeservice</a></li>
        <li><a routerLinkActive="active" routerLink="/bestemmelser">Bestemmelser</a></li>
        <li><a routerLinkActive="active" routerLink="/om">Om os</a>
        <li style="padding-right:20px;"><a routerLinkActive="active" routerLink="/kontakt">Kontakt</a></li>
      </ul>
    </div>
  </div>
</div>
<!-- /.navbar -->
<!-- <h2 style="color:red;  margin-top:20px; margin-left:30px;;  text-align: center;">Generalforsamling på Lynge kro, onsdag
  den 22. september 2021 kl. 19:30</h2> -->
